module.exports = __webpack_public_path__ + "static/img/route1.d8dcc6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/route1.jpg
// module id = 7LOC
// module chunks = 12